import {
  //TYPES
  MAP_UTILITIES_VEHICLE_LIST_SET,
  MAP_UTILITIES_VEHICLE_LIST_HIDDEN_TAGS,
  MAP_UTILITIES_VEHICLE_LIST_REFRESH,
  MAP_UTILITIES_VEHICLE_LIST_GET_UNIT,
  MAP_UTILITIES_VEHICLE_LIST_GET_UNIT_RESPONSE,
  MAP_UTILITIES_VEHICLE_LIST_GET_TAG_UNIT,
  MAP_UTILITIES_VEHICLE_LIST_GET_TAG_UNIT_RESPONSE
} from 'Redux/actionTypes';


export const setHiddenGroups = (hiddenGroupIds, value) => {
  return {
      type: MAP_UTILITIES_VEHICLE_LIST_SET,
      payload: { hiddenGroupIds: hiddenGroupIds, visible: value }
  };
}

export const setHiddenTags = (hiddenTagsIds = [], value) => {
    return {
        type: MAP_UTILITIES_VEHICLE_LIST_HIDDEN_TAGS,
        payload: { hiddenTagsIds: hiddenTagsIds }
    };
  }

export const refreshDataVehicleList = (refresh = false) => {
    return {
        type: MAP_UTILITIES_VEHICLE_LIST_REFRESH,
        payload: { refresh }
    }
}

export const getUnitVehicleList = (idVehicle) => {
    return {
        type: MAP_UTILITIES_VEHICLE_LIST_GET_UNIT,
        payload: { idVehicle }
    }
}

export const getUnitVehicleListResponse = (data, error = null) => {
    return {
        type: MAP_UTILITIES_VEHICLE_LIST_GET_UNIT_RESPONSE,
        payload: { data, error }
    }
}

export const getTagsVehicleList = () => {
    return {
        type: MAP_UTILITIES_VEHICLE_LIST_GET_TAG_UNIT,
        payload: { entityName: "Unit" }
    }
}

export const getTagsVehicleListResponse = (data, error = null) => {
    return {
        type: MAP_UTILITIES_VEHICLE_LIST_GET_TAG_UNIT_RESPONSE,
        payload: { data, error }
    }
}